import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { Link } from 'react-router-dom'
import CampaignsCombo from './CampaignsCombo'
import LeadChannelsSelect from '@/components/LeadChannelsSelect'

const STATUS_OPTIONS = [
	{ value: '', label: 'Select status', disabled: true },
	{ value: 'new', label: 'New' },
	{ value: 'lost', label: 'Lost' },
	{ value: 'won', label: 'Won' },
]

export default function LeadDetailsSection({ form, setField }) {
	return (
		<div>
			<h3 className="text-lg font-semibold text-gray-900 mb-6">Lead Details</h3>

			<div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
				<div className="lg:col-span-1">
					<label htmlFor="source" className="block text-sm font-medium text-gray-700 mb-2">
						How did you hear about us?{' '}
						<Link to="/settings?tab=leadchannels" className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200">
							Lead Channels
						</Link>
					</label>
					<LeadChannelsSelect
						id="source"
						name="source"
						value={form.source}
						onChange={e => setField('source', e.target.value)}
						placeholder="Select source"
						className="block w-full rounded-lg border-0 py-2.5 pl-3.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm bg-white transition-colors"
					/>
				</div>

				<div className="lg:col-span-1">
					<label htmlFor="campaign" className="block text-sm font-medium text-gray-700 mb-2">
						Campaign Name
					</label>
					<CampaignsCombo
						id="campaign"
						value={form.campaign}
						onChange={value => setField('campaign', value)}
						placeholder="Search or create a campaign"
					/>
				</div>

				<div className="lg:col-span-1">
					<label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-2">
						Lead Status
					</label>
					<div className="relative">
						<select
							id="status"
							name="status"
							value={form.status}
							onChange={e => setField('status', e.target.value)}
							className="block w-full appearance-none rounded-lg border-0 py-2.5 pl-3.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm bg-white transition-colors">
							{STATUS_OPTIONS.map(opt => (
								<option key={opt.value || 'placeholder'} value={opt.value} disabled={opt.disabled}>
									{opt.label}
								</option>
							))}
						</select>
						<ChevronDownIcon
							aria-hidden="true"
							className="pointer-events-none absolute right-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
